import { render, staticRenderFns } from "./card-attaching-zones.vue?vue&type=template&id=008e76b0&scoped=true&"
import script from "./card-attaching-zones.vue?vue&type=script&lang=js&"
export * from "./card-attaching-zones.vue?vue&type=script&lang=js&"
import style0 from "./card-attaching-zones.vue?vue&type=style&index=0&id=008e76b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008e76b0",
  null
  
)

export default component.exports